<!--<error-message iconClass="fa fa-eye-slash fa-3x" tittleKey="" messageKey="General.access.visualizationDenied.message">
</error-message>-->


<div class="wrapper wrapper-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-center m-b-md m-t-md">
        <div class="col-10 alert alert-info pt-5 pb-5">
          <i class="fas fa-3x fa-eye-slash m-r-md d-block col-12 text-center" aria-hidden="true"></i>
          <span class="text-justify p-5 d-block jus"> {{'General.access.visualizationDenied.message' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>